import { render, staticRenderFns } from "./PotensiView.vue?vue&type=template&id=737e13ec&scoped=true"
import script from "./PotensiView.vue?vue&type=script&lang=js"
export * from "./PotensiView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737e13ec",
  null
  
)

export default component.exports